export default window.URL
